export default "/_next/static/images/use-cases--magnet-legacy-c99af2490f07247e4df2c64b3955131c.svg";